import React, { Fragment, useState, useEffect } from 'react';
import { Row, Card, CardBody } from 'reactstrap';

import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { NavLink } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  faPalette,
  faLanguage,
  faComment,
  faLocationArrow,
} from '@fortawesome/free-solid-svg-icons';
import {
  AxiosAPI,
  getGroupID,
  getUserRole,
} from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Internal_Property_By_Id,
  putAPI_Update_HideStats,
} from '../../../../../constants/APIs';
import { BusinessProfileSetting } from './BusinessProfileSetting';
import BusinessDataPolicy from './BusinessDataPolicies';
import HideStats from './HideStats';
import Topics from './Topics';
function BusinessSettingList({ match, history, propertyId, isSuperAdmin }) {
  const [isBusinessProfile, setIsBusinessProfile] = useState(true);
  const [isDataPolicy, setIsDataPolicy] = useState(false);
  const [isHideStats, setIsHideStats] = useState(false);
  const [isVoucherInfo, setIsVoucherInfo] = useState(false);
  const [propertyData, setPropertyData] = useState(null);
  const [isTopicInfo, setIsTopicInfo] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const role = getUserRole();
    console.log('123', role);
    if (role === 'SuperAdmin' || isSuperAdmin) {
      setHasAccess(true);
    } else {
      setHasAccess(false);
    }
  }, []);
  const fetchProperty = () => {
    if (propertyId !== undefined && propertyId !== '-1') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setPropertyData(res.data);
        })
        .catch((err) => console.log('err', err));
    }
  };
useEffect(() => {
    fetchProperty();
}, [propertyId]);

  const setBusinessProfile = () => {
    setIsBusinessProfile(true);
    setIsDataPolicy(false);
    setIsVoucherInfo(false);
    setIsHideStats(false);
    setIsTopicInfo(false);
  };

  const handleTopicInfo = () => {
    setIsBusinessProfile(false);
    setIsDataPolicy(false);
    setIsVoucherInfo(false);
    setIsHideStats(false);
    setIsTopicInfo(true);
  };

  const setDataPolicy = () => {
    setIsBusinessProfile(false);
    setIsDataPolicy(true);
    setIsVoucherInfo(false);
    setIsTopicInfo(false);
    setIsHideStats(false);
  };
  const setHideStats = () => {
    setIsBusinessProfile(false);
    setIsDataPolicy(false);
    setIsVoucherInfo(false);
    setIsTopicInfo(false);
    setIsHideStats(true);
  };
  return (
    <Fragment>
      <Row>
        <Colxx xxs="12" md="6" className="mb-4">
          <Card>
            <CardBody>
              <div
                className={`mb-3 integration ${
                  isBusinessProfile ? 'integration--active' : ''
                }`}
              >
                <div className="glyph">
                  <div className={`glyph-icon iconsminds-hotel`} />
                </div>
                <NavLink
                  to="#"
                  className="w-40 w-sm-100"
                  onClick={(e) => setBusinessProfile()}
                >
                  <Row>
                    <Colxx xxs="12" md="10">
                      <p className="list-item-heading mb-1 color-theme-1">
                        Business Profile
                      </p>
                      <p className="mb-4 text-small">
                        Business information like name, address, and logo
                      </p>
                    </Colxx>
                    <Colxx xxs="12" md="2">
                      <div className="glyph">
                        <div
                          className={`glyph-icon-min iconsminds-arrow-forward-2`}
                        />
                      </div>
                    </Colxx>
                  </Row>
                </NavLink>
                <Separator />
              </div>
              {/* <div
                                className={`mb-3 integration ${isVoucherInfo ? 'integration--active' : ''
                                    }`}
                            >
                                <div className="glyph">
                                    <FontAwesomeIcon icon={faPalette} className="fa" />
                                </div>
                                <NavLink
                                    to="#"
                                    className="w-40 w-sm-100"
                                    onClick={(e) => setVoucherInfo()}
                                >
                                    <Row>
                                        <Colxx xxs="12" md="10">
                                            <p className="list-item-heading mb-1 color-theme-1">
                                                Voucher Info
                                            </p>
                                            <p className="mb-4 text-small">
                                                Information to print on vouchers and eGift Cards
                                            </p>
                                        </Colxx>
                                        <Colxx xxs="12" md="2">
                                            <div className="glyph">
                                                <div
                                                    className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                />
                                            </div>
                                        </Colxx>
                                    </Row>
                                </NavLink>
                                <Separator />
                            </div> */}
              <div
                className={`mb-3 integration ${
                  isDataPolicy ? 'integration--active' : ''
                }`}
              >
                <div className="glyph">
                  <div className={`glyph-icon simple-icon-game-controller`} />
                </div>
                <NavLink
                  to="#"
                  className="w-40 w-sm-100"
                  onClick={(e) => setDataPolicy()}
                >
                  <Row>
                    <Colxx xxs="12" md="10">
                      <p className="list-item-heading mb-1 color-theme-1">
                        Business Data Policies
                      </p>
                      <p className="mb-4 text-small">
                        Define your data retention policies
                      </p>
                    </Colxx>
                    <Colxx xxs="12" md="2">
                      <div className="glyph">
                        <div
                          className={`glyph-icon-min iconsminds-arrow-forward-2`}
                        />
                      </div>
                    </Colxx>
                  </Row>
                </NavLink>
                <Separator />
              </div>
              <div
                className={`mb-3 integration ${
                  isHideStats ? 'integration--active' : ''
                }`}
              >
                <div className="glyph">
                  <div className={`glyph-icon simple-icon-game-controller`} />
                </div>
                <NavLink
                  to="#"
                  className="w-40 w-sm-100"
                  onClick={(e) => setHideStats()}
                >
                  <Row>
                    <Colxx xxs="12" md="10">
                      <p className="list-item-heading mb-1 color-theme-1">
                        Data Insights
                      </p>
                      <p className="mb-4 text-small">
                        Customize the data insights view
                      </p>
                    </Colxx>
                    <Colxx xxs="12" md="2">
                      <div className="glyph">
                        <div
                          className={`glyph-icon-min iconsminds-arrow-forward-2`}
                        />
                      </div>
                    </Colxx>
                  </Row>
                </NavLink>
                <Separator />
              </div>
              <div
                className={`mb-3 integration ${
                  isTopicInfo ? 'integration--active' : ''
                }`}
              >
                <div className="glyph">
                  <div className={`glyph-icon simple-icon-menu`} />
                </div>
                <NavLink
                  to="#"
                  className="w-40 w-sm-100"
                  onClick={(e) => handleTopicInfo()}
                >
                  <Row>
                    <Colxx xxs="12" md="10">
                      <p className="list-item-heading mb-1 color-theme-1">
                        Topic Detection
                      </p>
                      <p className="mb-4 text-small">
                        Detects the main topics in conversations, helping you
                        categorize, view, and analyze conversations by topic.
                      </p>
                    </Colxx>
                    <Colxx xxs="12" md="2">
                      <div className="glyph">
                        <div
                          className={`glyph-icon-min iconsminds-arrow-forward-2`}
                        />
                      </div>
                    </Colxx>
                  </Row>
                </NavLink>
                <Separator />
              </div>
              {/* <div>
                               <Button
                                    color="dark"
                                    style={{
                                        width: '100%',
                                        borderRadius: '6px',
                                    }}
                                    className="mb-4"
                                    onClick={RedirectToDemo}
                                >
                                    Preview
                                </Button> 

                                <Separator />
                            </div>
                            <div>
                                <Button
                                    color="dark"
                                    outline
                                    style={{
                                        width: '100%',
                                        borderRadius: '6px',
                                    }}
                                    className="mb-4"
                                    onClick={toggle}
                                >
                                    Archive
                                </Button>

                                <Separator />
                            </div> */}
            </CardBody>
          </Card>
        </Colxx>
        <Colxx xxs="12" md="6" className="mb-4">
          {isBusinessProfile && (
            <Fragment>
              <BusinessProfileSetting
                propertyId={propertyId}
                property={propertyData}
                superAdmin={hasAccess}
                onSave={fetchProperty}
              />
            </Fragment>
          )}
          {isDataPolicy && (
            <Fragment>
              <BusinessDataPolicy
                propertyId={propertyId}
                property={propertyData}
                superAdmin={hasAccess}
                onSave={fetchProperty}
              />
            </Fragment>
          )}
          {isHideStats && (
            <Fragment>
              <HideStats propertyId={propertyId} property={propertyData} onSave={fetchProperty}/>
            </Fragment>
          )}
          {isTopicInfo && (
            <Fragment>
              <Topics propertyId={propertyId} property={propertyData} onSave={fetchProperty} />
            </Fragment>
          )}
        </Colxx>
      </Row>
    </Fragment>
  );
}
const mapStateToProps = ({ usersListApp, settings }) => {
  const { propertyId } = settings;
  const { isSuperAdmin } = usersListApp;
  return { propertyId, isSuperAdmin };
};

export default injectIntl(connect(mapStateToProps, {})(BusinessSettingList));
